const weatherConditionFromIconCode = (code) => {
    switch (code) {
        case '65':
        case '85':
            return 'clear';

        case '66':
        case '78':
            return 'partlyCloudy';

        case '67':
        case '69':
        case '70':
        case '72':
            return 'cloudy';

        case '74':
        case '76':
        case '77':
        case '82':
        case '84':
        case '87':
        case '88':
        case '89':
        case '90':
        case '95':
        case '96':        
            return 'rainy';

        case '83':
            return 'snowy';

        case '97':
        case '102':
            return 'clearNight';

        case '98':
            return 'partlyCloudyNight';

        case '75':
        case '99':
        case '103':
        case '104':
            return 'cloudyNight';

        case '101':
        case '105':
        case '106':
        case '107':
        case '108':
        case '116':
            return 'rainyNight';

        case '79':
        case '80':
        case '81':
        case '109':
        case '110':
        case '111':
        case '112':
        case '114':
            return 'snowyNight';

        default:
            return null;
    }
};

const getWeatherCategoryFromCondition = (condition = '') => {
  const conditionArray = condition.toLowerCase().replace('extreme ', 'extreme').split(' ');
  const fireWords = ['fire', 'volcano'];
  const floodWords = ['flood', 'surge', 'tsunami'];
  const landWords = ['avalanche', 'earthquake'];
  const humidityWords = ['humidity', 'humidex'];
  const heatWords = ['heat', 'uv'];
  const hurricaneWords = ['hurricane', 'tropical', 'typhoon', 'waterspout'];
  const airWords = ['air', 'aviation', 'fog', 'fog-smoke', 'wind'];
  const blizzardWords = ['arctic', 'blizzard', 'hail', 'winter'];
  const debrisWords = ['ashfall', 'dust', 'smoke'];
  const rainWords = ['rain', 'rainfall'];
  const seaWords = ['seas', 'surf', 'hydrologic', 'water', 'marine', 'current', 'craft'];
  const shelterWords = ['evacuation', 'law', 'shelter'];
  const snowWords = ['snow', 'cold', 'freeze', 'freezing', 'frost', 'chill'];
  const stormWords = ['thunderstorm', 'thunderstorms', 'storm', 'weather', 'special', 'weather'];
  const tornadoWords = ['funnel', 'extreme', 'gale', 'landspout', 'convective', 'tornado', 'wreckhouse'];
  const toxicWords = ['hazardous', 'hazard', 'nuclear'];

  if (conditionArray.some((word) => snowWords.indexOf(word) !== -1)){
    return 'snow';
  } else if (conditionArray.some((word) => fireWords.indexOf(word) !== -1)){
    return 'fire';
  } else if (conditionArray.some((word) => hurricaneWords.indexOf(word) !== -1)){
    return 'hurricane';
  } else if (conditionArray.some((word) => tornadoWords.indexOf(word) !== -1)){
    return 'tornado';
  } else if (conditionArray.some((word) => airWords.indexOf(word) !== -1)){
    return 'air';
  } else if (conditionArray.some((word) => debrisWords.indexOf(word) !== -1)){
    return 'debris';
  } else if (conditionArray.some((word) => rainWords.indexOf(word) !== -1)){
    return 'rain';
  } else if (conditionArray.some((word) => humidityWords.indexOf(word) !== -1)){
    return 'humidity';
  } else if (conditionArray.some((word) => heatWords.indexOf(word) !== -1)){
    return 'heat';
  } else if (conditionArray.some((word) => floodWords.indexOf(word) !== -1)){
    return 'flood';
  } else if (conditionArray.some((word) => landWords.indexOf(word) !== -1)){
    return 'land';
  } else if (conditionArray.some((word) => blizzardWords.indexOf(word) !== -1)){
    return 'blizzard';
  } else if (conditionArray.some((word) => seaWords.indexOf(word) !== -1)){
    return 'sea';
  } else if (conditionArray.some((word) => shelterWords.indexOf(word) !== -1)){
    return 'shelter';
  } else if (conditionArray.some((word) => toxicWords.indexOf(word) !== -1)){
    return 'toxic';
  } else if (conditionArray.some((word) => stormWords.indexOf(word) !== -1)){
    return 'storm';
  }

  return 'alert';
};

/**
 * Temperature conversion Fahrenheit to Celsius
 * 
 * @param { string }: Fahrenheit value
 * 
 * @returns { string }: Celsius value
 */
const convertF2C = (fValue) => {
  return Math.round( (fValue - 32)*(5/9) );
}

export { weatherConditionFromIconCode, getWeatherCategoryFromCondition, convertF2C };



// WEBPACK FOOTER //
// ./app/utils/WeatherUtils.js